import { authorizedInstance } from "../config/axios"

export const illustrationLogs = async ({
  accessionNo,
  logType,
  inboundMessageId,
}) => {
  const query = new URLSearchParams({
    accessionNo,
    logType,
    inboundMessageId,
  })
  const response = await authorizedInstance.get(`illustration-logs?${query}`)
  return response.data
}

export const getAllIllustrationResults = async (filters) => {
  const params = new URLSearchParams(filters)

  const response = await authorizedInstance.get(
    `/all-illustration-logs?${params}`
  )
  return response.data
}

export const getIllustrationLogsByAccessionNo = async (filters) => {
  const params = new URLSearchParams(filters)
  const response = await authorizedInstance.get(
    `/all-illustration-logs/log?${params}`
  )
  return response.data
}
